define('OutSystems/ReactWidgets/Dropdown',["require", "exports", "tslib", "OutSystems/ReactView/Widget", "react", "./DropdownCustom", "./DropdownNative"], function (require, exports, tslib_1, Widget_1, React, DropdownCustom_1, DropdownNative_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Dropdown = void 0;
    var Dropdown = (function (_super) {
        tslib_1.__extends(Dropdown, _super);
        function Dropdown() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Dropdown.prototype.render = function () {
            if (this.props.dropdownMode === 1) {
                return React.createElement(DropdownCustom_1.DropdownCustom, tslib_1.__assign({}, this.props));
            }
            else {
                return React.createElement(DropdownNative_1.DropdownNative, tslib_1.__assign({}, this.props));
            }
        };
        Dropdown = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Dropdown);
        return Dropdown;
    }(Widget_1.InputWithVariableWidget));
    exports.Dropdown = Dropdown;
});
//# sourceMappingURL=Dropdown.js.map;
